(function ($) {
  function resetSubmitState($modal) {
    var $form = $modal.find('form');
    if ($form.length && !$form.hasClass('submitting')){
      $form.find('button[type="submit"]')
        .removeClass('disabled')
        .prop('disabled',false);
    }
  }
  $(document).ready(function() {
    $('.application-container').on('click', 'form button[type="submit"]', function () {
      var $form = $(this).closest('form');
      if ($form.length && $form[0].checkValidity()) {
        $(this).addClass('submitter');
      } else {
        $(this).removeClass('submitter');
      }
    })
    $('.application-container').on('submit', 'form', function (event) {
      if ($(this).hasClass('submitting')) {
        event.preventDefault();
        return false;
      }
      $(this).addClass('submitting');
      var submitBtn = $(this).find('button[type="submit"]');
      submitBtn.addClass('disabled');
      if(submitBtn.parents('.modal').length) {
        submitBtn.prop('disabled', true);
      }
      var $submitting = $(this).find('.submitter');
      if ($submitting.length && $submitting.find('.spinner').length === 0) {
        $submitting.prepend('<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>');
      }
    })
    $('.application-modal').on('shown.bs.modal', function () {
      resetSubmitState($(this));
    })
    $('.js-datepicker').each(function () {
      var options = {
        language: 'nl',
      };
      var $container = $(this).parents('.form-group');
      if ($container.length) {
        options.container = $container;
      }
      $(this).datepicker(options)
      $(this).inputmask('99/99/9999',{ 'placeholder': '__/__/____' })
    })
    $('.js-zip-code, .js-house-number').on('change', function () {
      var addressIndex = $(this).data('address-index');
      var postcode = $('.js-zip-code[data-address-index="'+addressIndex+'"]').val();
      var houseNumber = $('.js-house-number[data-address-index="'+addressIndex+'"]').val();
      if (postcode && houseNumber) {
        $.get('/application/autocompletePlace/', {
          postcode: postcode,
          houseNumber: houseNumber,
        }, function (data) {
          var $street = $('.js-street[data-address-index="'+addressIndex+'"]');
          var $city = $('.js-city[data-address-index="'+addressIndex+'"]');
          if (data.hasResult === false) {
            if ($street.length) {
              var $label = $street.siblings('label');
              if ($label.find('.form-error-message').length) {
                $label.find('.form-error-message').text('Het adres kan niet worden gevonden, vul het handmatig in.');
              } else {
                $label.append('<span class="invalid-feedback d-block"><span class="d-block"> <span class="form-error-icon badge badge-danger text-uppercase">Fout</span> <span class="form-error-message">Het adres kan niet worden gevonden, vul het handmatig in.</span> </span></span>');
              }
            }
          } else {
            var firstResult = data.result[0];
            if ($street.length) {
              $street.find('.invalid-feedback ').remove();
              $street.val(firstResult.straat);
            }
            if ($city.length) {
              $city.val(firstResult.plaats);
            }
          }
        })
      }

    })
  });
})(jQuery);



// WEBPACK FOOTER //
// resources/assets/application/js/application.js